import { execute, INSERT, SELECT, UPDATE } from "@/utils/database_module";
import { User, UserData } from "@/utils/types";
import { SHA256 } from "crypto-js";
import moment from "moment";

const users = {
    getAll : async (filter : { limit? : number, currentPage? : number, searchQuery? : string, order? : string, role? : string, startDate? : string, endDate? : string}) => {
        let { limit, currentPage, searchQuery, order, role, startDate, endDate} = filter
        if (!limit) limit = 1000000
        if (!currentPage) currentPage = 1

        const searchQueryStr = searchQuery ? `AND (first_name LIKE '%${searchQuery}%' OR last_name LIKE '%${searchQuery}%')` : "";
        let limitStr = !isNaN(parseInt(`${limit * currentPage}`)) ? parseInt(`${limit * currentPage}`) : limit;
        const orderStr = order? ` ORDER BY ${order}` : "ORDER BY date DESC"
        const startDateStr= startDate &&  startDate!= ""  ? ` AND DATE(users.date) >= '${moment(startDate).format("YYYY-MM-DD")}'`: ""
        const endDateStr= endDate &&  endDate!= ""   ? ` AND DATE(users.date) <= '${moment(endDate).format("YYYY-MM-DD")}'`: "";
        const roleStr = role ? ` AND role = '${role}'` : ""
        
        const query = `SELECT * FROM users WHERE is_deleted=0  ${searchQueryStr} ${roleStr} ${startDateStr}   ${endDateStr} ${orderStr}   LIMIT ${limitStr}`;
        const users = await execute(query) as User[];

        // * Count the total number of users without the limit and offset
        const usersTotalNumberQuery =  await execute( `SELECT id FROM users WHERE is_deleted=0  ${searchQueryStr} ${roleStr} ${startDateStr}   ${endDateStr} `) as User[]
        const usersTotalNumber = usersTotalNumberQuery.length

        for (const user of users) {
            user.phone_numbers = typeof   user.phone_numbers ?  JSON.parse(`${user?.phone_numbers}`)   :   user.phone_numbers
            user.name = `${user.first_name} ${user.last_name}`
        }

        return { users, usersTotalNumber }
    },

    getOne : async (id : number) => {

        const [user] = (await SELECT(`users`, { conditions: [ { column: " id", operator: "=", value:  id, }], })) as User[];

        if (!user) throw new Error("User not found");
        user.phone_numbers = typeof   user.phone_numbers ?  JSON.parse(`${user?.phone_numbers}`)   :   user.phone_numbers
        return user
    },

    login : async (email : string, password : string) => {
      const [user] = (await SELECT(`users`, { conditions: [ { column: " email", operator: "=", value:  email, }], })) as User[];
      if (!user) throw new Error("User not found");

      const hashedPassword = SHA256(password).toString();
      if (user.password !== hashedPassword) throw new Error("Invalid password");
      user.permissions =typeof user.permissions === "string" ? JSON.parse(`${user.permissions}`) : user.permissions
      return user
    },

    insert : async (user : UserData) => {
        // * Fetch existing users with the same email
        const existingUsers = await SELECT(`users`, { conditions: [ { column: " email", operator: "=", value:  user.email, } , { column: " is_deleted", operator: "=", value:  0 } ], }) as User[];
        if (existingUsers.length > 0)  throw new Error("emailAlreadyUsed"); 
        
        return await INSERT("users", user);
    },

    update : async (id : number, user : any) => {
      const updatedUser = user.phone_numbers ? { ...user, phone_numbers: JSON.stringify(user.phone_numbers) } : user;
      return await UPDATE("users", updatedUser, [{ column: "id", operator: "=", value: id }]);
    },


    delete : async (id : number) => {
      return await UPDATE("users", { is_deleted: 1 }, [{ column: "id", operator: "=", value: id }]);
    },

}
 export default users;




 